<template>
    <v-alert
        :type="type"
        transition="slide-y-transition"
        dense
    >
        <slot></slot>
    </v-alert>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            required: true
        }
    }
}
</script>
